import React from 'react';
import { Card, Form, Input, Button } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { formItemLayout, getUrlSearchParams } from 'utils/utils.js';
import styles from './Index.less';

const FormItem = Form.Item;

@connect(({ loading, standardCRUDDetail }) => ({
  submitting: loading.effects['standardCRUDDetail/submit'],
  loading: loading.effects['standardCRUDDetail/fetchDetail'],
  detail: standardCRUDDetail.detail,
}))
@Form.create()
export default class Index extends React.Component {
  constructor(props) {
    super(props);

    this.searchParams = getUrlSearchParams(props.location);
    console.log('form type:', this.searchParams.type);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.renderName = this.renderName.bind(this);
  }

  componentDidMount() {
    if (this.searchParams.type === 'edit' || this.searchParams.type === 'query') {
      this.props.dispatch({
        type: 'standardCRUDDetail/fetchDetail',
        id: this.searchParams.id,
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: 'standardCRUDDetail/resetState' });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props
          .dispatch({
            type: 'standardCRUDDetail/submit',
            payload: values,
          })
          .then(() => {
            this.props.dispatch(routerRedux.replace('/demo/standardCRUD/list'));
          });
      }
    });
  }

  renderName() {
    const { type } = this.searchParams;
    const { getFieldDecorator } = this.props.form;
    const { detail } = this.props;

    if (type === 'query') {
      return <div>{detail.name}</div>;
    }

    return getFieldDecorator('name', {
      initialValue: detail.name,
      rules: [{ required: true, message: '请输入姓名' }],
    })(<Input placeholder="请输入" />);
  }

  renderContent() {
    const { submitting } = this.props;
    const { type } = this.searchParams;

    return (
      <Form onSubmit={this.handleSubmit} className={styles.root}>
        <FormItem {...formItemLayout} label="姓名">
          {this.renderName()}
        </FormItem>

        <FormItem className="operation-button-wrap">
          {type !== 'query' && (
            <Button type="primary" htmlType="submit" loading={submitting}>
              提交
            </Button>
          )}
          <Button
            onClick={() => {
              this.props.dispatch(routerRedux.goBack());
            }}
          >
            返回
          </Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    const { loading } = this.props;
    return (
      <Card bordered={false} loading={loading}>
        {this.renderContent()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Demo/StandardCRUD/Detail/Index.js